import { render, staticRenderFns } from "./AddPartnerOrderMemberDlg.vue?vue&type=template&id=9b85f384&"
import script from "./AddPartnerOrderMemberDlg.vue?vue&type=script&lang=js&"
export * from "./AddPartnerOrderMemberDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddPartnerOrderMemberDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports